import clsx from "clsx";
import { Trans } from "react-i18next";
import { useCalculator } from "../../hooks/useCalculator";
import { CalculatorPeriod } from "../calculator-period/CalculatorPeriod";
import { CalculatorAsideContent } from "./CalculatorAsideContent";
import styles from "./CalculatorAside.module.css";

export const CalculatorAside: React.FC<{
  className?: string;
}> = ({ className }) => {
  const config = useCalculator((state) => state.config);

  return (
    <div className={clsx(styles.aside, className)}>
      <div className={styles.title}>
        <Trans>Payment Period</Trans>
      </div>
      <div className={styles.periods}>
        {config.periods.map((period) => (
          <CalculatorPeriod key={period.id} {...period} />
        ))}
      </div>
      <CalculatorAsideContent />
    </div>
  );
};
